export const SEG_LABELS = {
  drive_effectdeal: "Řídí auto EffectDeal", assist: "Pomocník / spolujezdec",
  waiting: "Čekání (klient, servis…)", drive_personal: "Řídí osobní auto jako řidič",
  return_own_car: "Cesta zpět vlastním autem", return_colleague: "Cesta zpět s kolegou (spolujezdec)",
  return_lift: "Odvoz kolegou vlastním autem (bez odměny)",
  fuel: "Tankování / dobíjení vozu", prep: "Příprava / kontrola vozu před předáním",
  service: "Servis / STK / pneuservis – doprovod vozu", admin: "Administrativa / jiná práce na pokyn",
};
// which hourly rate applies (null = unpaid, informational)
export const SEG_RATE_KEY = {
  drive_effectdeal: "drive_effectdeal", assist: "assist", waiting: "waiting", drive_personal: "drive_personal",
  return_own_car: "drive_personal", return_colleague: "assist", return_lift: null,
  fuel: "waiting", prep: "assist", service: "waiting", admin: "assist",
};
export const SEG_GROUPS = [
  ["Cesta a práce", ["drive_effectdeal", "drive_personal", "assist", "waiting"]],
  ["Cesta zpět", ["return_own_car", "return_colleague", "return_lift"]],
  ["Další činnosti", ["fuel", "prep", "service", "admin"]],
];
export const segRate = (type, rates) => { const k = SEG_RATE_KEY[type]; return k && rates ? Number(rates[k] || 0) : 0; };
export const RATE_LABELS = {
  drive_effectdeal: ["Řídí auto EffectDeal", "Kč / hod."], drive_personal: ["Dělá osobního řidiče (řídí tvoje auto)", "Kč / hod."],
  assist: ["Spolujezdec / pomocník na zakázce", "Kč / hod."], waiting: ["Čekání na klienta, servis apod.", "Kč / hod."],
  handover: ["Předání / převzetí auta klientovi", "Kč / úkon"], wash_exterior: ["Mytí auta – exteriér", "Kč / úkon"],
  wash_full: ["Kompletní čištění (interiér + exteriér)", "Kč / úkon"], weekend_bonus: ["Víkendový příplatek", "Kč / hod. navíc"],
  own_car_km: ["Cesta vlastním autem", "Kč / km"], min_hours: ["Minimální účtovaná doba", "hod."],
};
export const STATUS = {
  pending: { label: "Čeká na schválení", cls: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  approved: { label: "Schváleno", cls: "bg-sky-500/15 text-sky-300 border-sky-500/30" },
  paid: { label: "Vyplaceno", cls: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
};
export const czk = (n) => `${Number(n || 0).toLocaleString("cs-CZ", { maximumFractionDigits: 2 })} Kč`;
export const hrs = (n) => `${Number(n || 0).toLocaleString("cs-CZ", { maximumFractionDigits: 2 })} h`;
export const czDate = (s) => (s ? new Date(s + "T00:00:00").toLocaleDateString("cs-CZ", { day: "numeric", month: "numeric", year: "numeric" }) : "—");
export const segHours = (from, to) => {
  if (!from || !to) return 0;
  const [h1, m1] = from.split(":").map(Number); const [h2, m2] = to.split(":").map(Number);
  let mins = h2 * 60 + m2 - (h1 * 60 + m1); if (mins <= 0) mins += 1440;
  return Math.round((mins / 60) * 100) / 100;
};
// Client-side preview of the server calculation (same rules).
export const previewCalc = (job, rates) => {
  if (!rates) return null;
  let hours = 0; const lines = [];
  const segs = (job.segments || []).filter((s) => s.from && s.to);
  const paid = segs.filter((s) => SEG_RATE_KEY[s.type] !== null);
  segs.forEach((s) => { const h = segHours(s.from, s.to); const r = segRate(s.type, rates); if (SEG_RATE_KEY[s.type] !== null) hours += h; lines.push([SEG_LABELS[s.type], h * r]); });
  if (paid.length && hours > 0 && hours < (rates.min_hours || 0)) {
    const top = Math.max(...paid.map((s) => segRate(s.type, rates))); lines.push(["Minimální doba", (rates.min_hours - hours) * top]); hours = rates.min_hours;
  }
  const d = job.date ? new Date(job.date + "T00:00:00").getDay() : 1;
  if ((d === 0 || d === 6) && hours > 0 && rates.weekend_bonus) lines.push(["Víkend", hours * rates.weekend_bonus]);
  if (Number(job.handovers)) lines.push(["Předání", Number(job.handovers) * rates.handover]);
  if (Number(job.wash_exterior)) lines.push(["Mytí", Number(job.wash_exterior) * rates.wash_exterior]);
  if (Number(job.wash_full)) lines.push(["Čištění", Number(job.wash_full) * rates.wash_full]);
  if (Number(job.own_car_km)) lines.push(["Vlastní auto", Number(job.own_car_km) * rates.own_car_km]);
  const exp = (job.expenses || []).reduce((s, e) => s + (Number(e.amount) || 0), 0);
  if (exp) lines.push(["Náklady", exp]);
  return { hours, total: lines.reduce((s, l) => s + l[1], 0), lines };
};
